<template lang="pug">
  Modal
    h1 Deprecate Media
</template>
<script>
import Modal from '../general/Modal';
export default {
  name: 'deprecateMedia',
  components: {
    Modal
  }
};
</script>




// WEBPACK FOOTER //
// src/components/modals/DeprecateMedia.vue